module.exports = __webpack_public_path__ + "static/media/bartender.88bea1f4.jpg";